import { InteractiveContainer } from "@jugl-web/ui-kit";
import { cx } from "@jugl-web/utils";
import { FC, ReactNode } from "react";

export interface BaseListItemProps {
  startSlot: ReactNode;
  title: ReactNode;
  subtitle: ReactNode;
  endSlot?: ReactNode;
  isSelected?: boolean;
  className?: string;
  onClick: () => void;
}

export const BaseListItem: FC<BaseListItemProps> = ({
  startSlot,
  title,
  subtitle,
  endSlot,
  isSelected = false,
  className,
  onClick,
}) => (
  <InteractiveContainer
    className={cx(
      "mb-3 flex items-start justify-between gap-1 rounded-xl px-3 py-2 transition-colors",
      isSelected ? "bg-primary-50 hover:bg-primary-50" : "hover:bg-grey-100",
      className
    )}
    onClick={onClick}
  >
    <div className="flex items-center gap-3 overflow-hidden">
      <div className="shrink-0">{startSlot}</div>
      <div className="flex flex-col gap-0.5 overflow-hidden text-left">
        <span className="truncate font-secondary text-sm leading-[21px] text-dark">
          {title}
        </span>
        <span className="truncate font-secondary text-sm leading-[140%] text-grey-800">
          {subtitle}
        </span>
      </div>
    </div>
    {endSlot}
  </InteractiveContainer>
);
